export default{
  "Video Compressor": "ビデオコンプレッサー",
  "HitPaw Online Video Compressor": "HitPawオンラインビデオコンプレッサー",
  "Best video compressor tool to reduce video file size online without losing quality.": "品質を落とさずにオンラインでビデオのファイルサイズを縮小する最高のビデオ圧縮ツール",
  "Quality": "品質",
  "Small Size": "小さいサイズ（{{num}}％）",
  "High Quality": "高品質（{{num}}％）",
  "Frame Rate": "フレームレート",
  "Resolution": "解像度",
  "Keep Resolution": "解像度の保持",
  "Format": "フォーマット",
  "Compress": "圧縮",
  "Compressing": "圧縮中",
  "Compress New": "新たに圧縮",
  "xx% reduction in size!": "サイズを{{num}}％削減！",
  "Compressed successfully, your file is now xxMB.": "圧縮成功しました。あなたのファイルは現在<p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>です",
  "Compression Failed": "圧縮失敗しました。",
};